import { render, staticRenderFns } from "./quickBIDesign.vue?vue&type=template&id=69f89c0c&"
import script from "./quickBIDesign.vue?vue&type=script&lang=js&"
export * from "./quickBIDesign.vue?vue&type=script&lang=js&"
import style0 from "./quickBIDesign.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports